import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransferArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 12,
	viewBox: "0 0 22 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.3327 1.0978C10.7125 0.757553 11.2875 0.757554 11.6673 1.0978L21.6098 10.0052C22.2932 10.6175 21.8601 11.75 20.9425 11.75H1.05748C0.139883 11.75 -0.293231 10.6175 0.390213 10.0052L10.3327 1.0978Z",
		fill: "#0C8527"
	})
});
export default SvgTransferArrowUp;
